import Async from 'react-select/lib/Async';
import { connect } from 'react-redux';
import { primary_s20_l95 } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import './AsyncSelect.scss';

const getStyle = ({ primaryColor, isHeader = false, uiVariantInputText }) => {
  return css`
    &.is-focused,
    &.is-focused:not(.is-open),
    &.is-open {
      .Select-control {
        border-color: ${primaryColor};
      }
    }

    .Select-value,
    .Select-placeholder,
    .Select-noresults {
      padding-top: ${isHeader ? '1px' : '2px'};
      padding-left: ${isHeader ? '25px' : '15px'}!important;

      @media (min-width: 992px) {
        padding-top: ${isHeader ? '4px' : '2px'};
      }
    }

    .Select-control {
      height: ${isHeader ? '30px' : '40px'};
      border-radius: ${uiVariantInputText === '1'
        ? '12px'
        : uiVariantInputText === '3'
        ? '30px'
        : 0};
      &:focus {
        border-color: ${primaryColor}!important;
      }

      @media (max-width: 768px) {
        font-size: 16px;
      }

      @media (min-width: 992px) {
        height: ${isHeader ? '45px' : '40px'};
      }

      .Select-input {
        padding-left: ${isHeader ? '25px' : '15px'};
        height: ${isHeader ? '36px' : '38px'};

        input {
          padding: ${isHeader ? '10px 0' : '10px 0 12px'};

          @media (max-width: 768px) {
            font-size: 16px;
          }

          @media (min-width: 992px) {
            padding: ${isHeader ? '13px 0' : '10px 0 12px'};
          }
        }
      }

      .Select-arrow-zone {
        padding-left: ${isHeader ? '10px' : 0};
        padding-right: ${isHeader ? '20px' : '15px'};
        padding-bottom: ${isHeader ? 0 : '4px'};

        svg {
          color: ${primaryColor};
        }

        .Select-arrow {
          border-color: ${primaryColor} transparent transparent;
        }
      }
    }
    &.is-open {
      .Select-control {
        .Select-arrow {
          border-color: transparent transparent ${primaryColor};
        }
      }
    }

    .Select-menu-outer {
      border-color: ${primaryColor};
    }

    .Select-option {
      padding: ${isHeader ? 0 : '5px 15px'};

      &.is-selected,
      &.is-focused {
        background-color: ${primary_s20_l95(primaryColor)};
      }
    }
  `;
};

const AsyncSelect = props => <Async css={getStyle(props)} {...props} />;

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputText: state.store.data.uiVariants.inputText,
});

export default connect(mapStateToProps)(AsyncSelect);
